import { gql } from "urql";
export const CreateLocationMutation = gql `
    mutation CreateLocation(
        $name: String!
        $address1: String
        $address2: String
        $city: String
        $stateName: String
        $postalCode: String
        $isPrimary: Boolean
        $imageKey: String
        $imageVersion: String
    ) {
        locations {
            createLocation(
                input: {
                    name: $name
                    address1: $address1
                    address2: $address2
                    city: $city
                    stateName: $stateName
                    postalCode: $postalCode
                    isPrimary: $isPrimary
                    imageKey: $imageKey
                    imageVersion: $imageVersion
                }
            ) {
                locationId
                organizationId
                organizationName
                name
                address1
                address2
                city
                stateId
                stateName
                postalCode
                isPrimary
                isActive
                imageUrl
            }
        }
    }
`;
export const UpdateLocationMutation = gql `
    mutation UpdateLocation(
        $locationId: String!
        $name: String
        $address1: String
        $address2: String
        $city: String
        $stateName: String
        $postalCode: String
        $isPrimary: Boolean
        $imageKey: String
        $imageVersion: String
        $latitude: Float
        $longitude: Float
        $isActive: Boolean
    ) {
        locations {
            updateLocation(
                input: {
                    locationId: $locationId
                    name: $name
                    address1: $address1
                    address2: $address2
                    city: $city
                    stateName: $stateName
                    postalCode: $postalCode
                    isPrimary: $isPrimary
                    imageKey: $imageKey
                    imageVersion: $imageVersion
                    latitude: $latitude
                    longitude: $longitude
                    isActive: $isActive
                }
            ) {
                locationId
                organizationId
                organizationName
                name
                address1
                address2
                city
                stateId
                stateName
                postalCode
                isPrimary
                isActive
                imageUrl
            }
        }
    }
`;
export const DeleteLocationMutation = gql `
    mutation DeleteLocation($locationId: String!) {
        locations {
            deleteLocation(locationId: $locationId) {
                locationId
            }
        }
    }
`;
